export enum CountryConfigurationKeyEnum {
    Currency = "currency",
    TaxRate = "taxRate",
    CountryLegalIdentifiers = "countryLegalIdentifier",
    BidRange = "bidRange",
    ActivityReport = "activityReport",
}
